import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  LineChart,
  Line,
  Legend,
  LabelList
} from "recharts";
import { useEffect,useRef, useState } from "react";
import Loader from "../../../common/loader";
import { Download } from "lucide-react";
import EmptyState from "../../common/EmptyState";
const ChartCard = ({ title, data, chartType, isLoading = false, size ,exportToExcel}) => {
  const [isLegendExpanded, setIsLegendExpanded] = useState(true);

  const colors = [
    "#184F45",
    "#2B6D62",
    "#4D948B",
    "#76A693",
    "#A3C3B9",
    "#CFE3D6",
  ];
  const gradientColors = ["#184F45", "#2B6D62", "#4D948B", "#76A693", "#A3C3B9", "#CFE3D6"];
  // const renderPieLegend = (props) => {
  //   const { payload } = props;
  //   return (
  //     <div className="flex flex-wrap justify-center gap-2 p-1 text-[10px] text-gray-700">
  //       {payload.map((entry, index) => (
  //         <div key={`legend-${index}`} className="flex items-center gap-1 whitespace-nowrap">
  //           <div 
  //             className="w-3 h-3 rounded-full flex-shrink-0" 
  //             style={{ backgroundColor: entry.color }}
  //           />
  //           <span>{`${entry.value} (${data[index]?.value || 0}%)`}</span>
  //         </div>
  //       ))}
  //     </div>
  //   );
  // };

const renderPieLegend = (props) => {
    const { payload } = props;
    // Limit to ~6 items to roughly fill 2 rows
    const LIMIT = 6;
    const hasMore = payload.length > LIMIT;
    
    // If expanded, show all. If not, show only the limit.
    const visibleItems = isLegendExpanded ? payload : payload.slice(0, LIMIT);
    const remainingCount = payload.length - LIMIT;

    return (
      <div 
        className="custom-scrollbar mt-2 w-full overflow-y-auto px-2"
        style={{ 
          maxHeight: "35px", // Strictly limits legend height to ~2.5 rows
          minHeight: "25px" 
        }}
      >
        <div className="flex flex-wrap justify-center gap-x-2 gap-y-1 text-[10px] text-gray-700">
          {visibleItems.map((entry, index) => (
            <div key={`legend-${index}`} className="flex items-center gap-1 whitespace-nowrap">
              <div 
                className="w-2.5 h-2.5 rounded-full flex-shrink-0" 
                style={{ backgroundColor: entry.color }}
              />
              <span>{`${entry.value} (${data.find(d => d.name === entry.value)?.value || 0}%)`}</span>
            </div>
          ))}

          {/* This button stays inline as the last item in the flex container */}
          {/* {hasMore && (
            <button 
              onClick={(e) => {
                e.preventDefault();
                setIsLegendExpanded(!isLegendExpanded);
              }}
              className="text-emerald-700 font-bold hover:underline cursor-pointer whitespace-nowrap"
            >
              {isLegendExpanded ? " (Show less)" : ` + ${remainingCount} more`}
            </button>
          )} */}
        </div>
      </div>
    );
  };

  const renderChart = () => {
    console.log("Rendering chart with type:", chartType);
    switch (chartType) {
      case "pie":
        return (
          <PieChart>
              <Pie
        data={data}
        cx="50%"
        cy="50%"
        outerRadius={70}
        dataKey="value"
        nameKey="name"
        label={false}
        labelLine={false}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
        ))}
      </Pie>
           <Tooltip
        formatter={(value, name, props) => [
          `${props.payload.actual_value} (${value}%)`, 
          name
        ]}
        contentStyle={{ fontSize: "8px" }}
      />

      <Legend content={renderPieLegend} />
    </PieChart>
  );

case "bar":
        return (
         <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 0, bottom:0 }}
            barCategoryGap={35}  // 👈 Wider spacing for double width
            barGap={8}
            barSize={size === 'small' ? 16 : 32}         // 👈 Thicker bars
          >
            <CartesianGrid 
              vertical={false} 
              strokeDasharray="3 3" 
              stroke="#f1f5f9"
              strokeWidth={1}
              horizontalPoints={[]} // 👈 Enable horizontal lines
            />
            
           <XAxis
            dataKey="name"
            tickLine={false}
            axisLine={false}
            tickMargin={0}
            tick={<CustomXAxisTick size={size} textAnchor="middle" fontSize={size === 'small' ? 8 : 10} />}
            height={50}  // 👈 Increased for wrapped text
            angle={-40}
            interval={0}
          />
            {/* <YAxis
              tickLine={false}
              axisLine={false}
              tickMargin={10}
              tick={{ 
                fontSize: 11, 
                fontWeight: 500, 
                fill: "#64748b" 
              }}
              width={45}
            /> */}
             <Tooltip contentStyle={{ fontSize: "10px" }}
              itemStyle={{ fontSize: "10px" }}/>
            {/* <Tooltip content={<CustomTooltip  />} /> */}
            
            <Bar dataKey="value" radius={[6, 6, 0, 0]}>
              {data.map((entry, index) => (
                <Cell 
                  key={`cell-${index}`} 
                  fill={gradientColors[index % gradientColors.length]} 
                />
              ))}

                  {/* 2. Add LabelList with the custom renderer */}
    <LabelList 
      dataKey="value" 
      content={(props) => renderCustomizedLabel({...props, fontSize: size === 'small' ? 9 : 11})} 
    />
              {/* <LabelList content={CustomLabel} position="top" /> */}
            </Bar>
          </BarChart>
		  
        );

      case "line":
        return (
          <LineChart
            data={data}
            margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 10 }} />
            <YAxis tick={{ fontSize: 10 }} />
            <Tooltip
              contentStyle={{ fontSize: "10px" }}
              itemStyle={{ fontSize: "10px" }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="value"
              stroke={colors[0] || "#184F45"}
              strokeWidth={2}
              dot={{ r: 4 }}
            />
          </LineChart>
        );

      default:
        return <div className="text-gray-500 text-sm">Invalid chart type</div>;
    }
  };

  return (
    <div className="bg-white shadow-md rounded-2xl p-4 w-full">
      <div className="flex justify-between items-center">
        <h3 className="text-xs font-semibold mb-4">{title}</h3>
        <button className="text-emerald-800 hover:text-emerald-900 mb-4 hover:bg-gray-100 p-1 rounded-full" onClick={() => exportToExcel(title)}>
          <Download size={12}></Download>
        </button>
      </div>
      <div className="flex justify-center items-center h-[190px]">
        {isLoading ? (
          <Loader />
        ) : (
          <ResponsiveContainer width="100%" height={190}>
            {renderChart()}
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default ChartCard;




const CustomXAxisTick = ({ x, y, size, payload, textAnchor, fontSize = 8 }) => {
  const textRef = useRef(null);
  const [textHeight, setTextHeight] = useState(20);

  // Constants for constraints
  const maxWidthPerLine = size === 'small' ? 8 : 12; // Max characters per line
  const maxLines = 2; // Limit lines to prevent vertical overlap

  const words = payload.value.split(' ');
  
  const wrappedLines = words.reduce((acc, word) => {
    let lines = [...acc];
    const currentLineIdx = lines.length - 1;
    const currentLine = lines[currentLineIdx];

    // 1. Handle words that are longer than the entire line width
    const processedWord = word.length > maxWidthPerLine 
      ? word.substring(0, maxWidthPerLine - 3) + '...' 
      : word;

    // 2. Wrap logic
    if (currentLine === '') {
      lines[currentLineIdx] = processedWord;
    } else if ((currentLine + ' ' + processedWord).length <= maxWidthPerLine) {
      lines[currentLineIdx] += ' ' + processedWord;
    } else {
      lines.push(processedWord);
    }
    return lines;
  }, ['']);

  // 3. Ellipsis logic for line count overflow
  let finalLines = wrappedLines;
  if (wrappedLines.length > maxLines) {
    finalLines = wrappedLines.slice(0, maxLines);
    // Add ellipsis to the end of the last allowed line to indicate more text
    const lastLine = finalLines[maxLines - 1];
    finalLines[maxLines - 1] = lastLine.length > maxWidthPerLine - 3 
      ? lastLine.substring(0, maxWidthPerLine - 3) + '...'
      : lastLine + '...';
  }

  useEffect(() => {
    if (textRef.current) {
      const bbox = textRef.current.getBBox();
      setTextHeight(bbox.height + 8);
    }
  }, [payload.value]);

  return (
    <g transform={`translate(${x},${y})`}>
      <title>{payload.value}</title> 
      <text
        ref={textRef}
        x={0}
        y={10}
        dy={12} // Adjusted dy for better spacing
        textAnchor={textAnchor}
        fontSize={fontSize}
        fontWeight={500}
        fill="#64748b"
        className="recharts-tick"
      >
        {finalLines.map((line, i) => (
          <tspan key={i} x="0" dy={i === 0 ? 0 : '1.2em'}>
            {line}
          </tspan>
        ))}
      </text>
    </g>
  );
};


const renderCustomizedLabel = (props) => {
  const { x, y, width, value, fontSize = 10 } = props;
  
  // If value is 0, 'y' is the baseline (the X-axis). 
  // We subtract a small offset (e.g., 5 or 8) to push it above the axis.
  // If value > 0, we subtract 10 to clear the top of the bar.
  const verticalOffset = value === 0 ? 5 : 10;
  const yPos = y - verticalOffset;

  return (
    <text 
      x={x + width / 2} 
      y={yPos} 
      fill="#64748b" 
      textAnchor="middle" 
      fontSize={fontSize} 
      fontWeight={600}
    >
      {value}
    </text>
  );
};
